import { render, staticRenderFns } from "./Pointlist.vue?vue&type=template&id=b947e2bc&scoped=true&"
import script from "./Pointlist.vue?vue&type=script&lang=js&"
export * from "./Pointlist.vue?vue&type=script&lang=js&"
import style0 from "./Pointlist.vue?vue&type=style&index=0&id=b947e2bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b947e2bc",
  null
  
)

export default component.exports